import defaultLogger from './log'
import { CSRF_PROTECTION_HEADER_NAME, CSRF_PROTECTION_HEADER_VALUE } from './constants'
import { makeDebounce } from './timer-util'

function sendError(error, logger, serverAddress = '') {
    const urlRoute = window.location.hash ? window.location.hash?.replace('#/', '') : 'index'
    const url = `${serverAddress}/api/errorlog`
    const fetchOptions = {
        mode: 'cors',
        credentials: 'same-origin',
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            [CSRF_PROTECTION_HEADER_NAME]: CSRF_PROTECTION_HEADER_VALUE
        },
        body: JSON.stringify(Object.assign({}, error, { route: urlRoute, userAgent: navigator.userAgent }))
    }
    // Use fetch directly, because http-client would do too sophisticated error handling
    return fetch(url, fetchOptions).catch(error => logger.error(`Could not send error report: ${error}`))
}

// Wrap sendError function with a debouncer and set debounce period to 1000 ms. Decided for debouncing instead of
// throttling, because it may reduce server traffic better.
const debouncedSendError = makeDebounce(sendError, 1000)

/**
 * The application should use this function to record and log errors. It will send the reported error to the back-end.
 *
 * @param errorObject              - Some object containing error context information
 * @param [logger]                 - A logger object to log the error to e.g. console
 * @param [serverAddress]          - Absolute URL prefix (needed for unit tests, because there are no relative URLs
 *                                   allowed) [optional] - format: http[s]://serverName:serverPort
 */
export default function reportError(errorObject, logger = defaultLogger, serverAddress = '') {
    let body
    if (errorObject instanceof Error) {
        logger.error(`Caught error: ${errorObject.message} - caused by: ${errorObject.stack}`)
        const { message, name } = errorObject
        body = { name, message }
    } else if (typeof errorObject === 'string') {
        logger.error(`Caught error: ${errorObject}`)
        body = { message: errorObject }
    } else if (typeof errorObject === 'object') {
        logger.error(`Caught error: ${JSON.stringify(errorObject)}`)
        body = errorObject
    } else {
        logger.error(`Don't know how to handle error object`)
        body = { message: 'Unknown error occurred' }
    }
    return debouncedSendError(body, logger, serverAddress)
}
